import { render, staticRenderFns } from "./Page010.vue?vue&type=template&id=88dd258a&scoped=true&"
import script from "./Page010.vue?vue&type=script&lang=js&"
export * from "./Page010.vue?vue&type=script&lang=js&"
import style0 from "./Page010.vue?vue&type=style&index=0&id=88dd258a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dd258a",
  null
  
)

export default component.exports